import React, { useEffect, useRef } from 'react'
import { getCurrencyFormat } from '../../../../../constants/currencyFormat'
import NumberFormat from 'react-number-format'

export function NumberFormatCustom(props) {
  const {
    inputRef: handleGetInputRef,
    onChange,
    currencyFormat,
    isShowSign,
    type,
    prefix = '',
    suffix = '',
    value,
    ...other
  } = props
  const inputRef = useRef(null)

  let { decimalDigits, decimalSymbol, thousandSymbol } = props

  let format = {}

  if (currencyFormat) {
    format = getCurrencyFormat(currencyFormat, decimalDigits)
    decimalDigits = format.decimalDigits
    decimalSymbol = format.decimalSymbol
    thousandSymbol = format.thousandSymbol
  }
  let localVal = value
  if (localVal === true) {
    localVal = 0
  }
  localVal = parseFloat(localVal)
  if (isNaN(localVal)) {
    localVal = ''
  }

  useEffect(() => {
    if (value && type === 'currency') {
      const formattedValue = inputRef?.current?.value

      // if initial value is populated, emit formatted value right after first render
      if (formattedValue) {
        onChange({
          target: {
            value,
            name: props.name,
            formattedValue: `${prefix || ''}${formattedValue}${suffix || ''}`,
            isFormat: false,
          },
        })
      }
    }
  }, [])

  return (
    <NumberFormat
      {...other}
      {...(other.readOnly || other.disabled ? { role: 'textbox' } : {})}
      getInputRef={(element) => {
        // preserve input ref for internal usage and handle getting this ref by parent components
        if (handleGetInputRef && typeof handleGetInputRef === 'function') {
          handleGetInputRef(element)
        }

        inputRef.current = element
      }}
      value={localVal}
      type={'text'}
      pattern={'[0-9]*'}
      // displayType={other.readOnly || other.disabled ? "text" : "input"}
      onValueChange={(values, event) => {
        let isFormat = true
        try {
          let domElem = document.activeElement
          if (domElem && domElem.getAttribute('id') == props.id) {
            isFormat = false
          }
        } catch (err) {
          console.error(err)
        }
        if (values.value || localVal !== values.value) {
          onChange({
            target: {
              name: props.name,
              value: values.value ? parseFloat(values.value) : values.value,
              formattedValue: `${prefix || ''}${values.formattedValue}${suffix || ''}`,
              isFormat: isFormat,
            },
          })
        }
      }}
      fixedDecimalScale={true}
      decimalScale={decimalDigits}
      {...(Boolean(thousandSymbol) && thousandSymbol[0]
        ? { thousandSeparator: thousandSymbol[0] }
        : { thousandSeparator: false })}
      {...(Boolean(decimalSymbol) && decimalSymbol[0] ? { decimalSeparator: decimalSymbol[0] } : {})}
      isNumericString
      // prefix={prefix}
      // suffix={suffix}
      allowNegative={true}
    />
  )
}
